export const defaultSideBarPanels = [
    {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
            suppressValues: false
        }
    },
    {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel'
    },
    {
        id: 'adaptable',
        labelKey: 'adaptable',
        toolPanel: 'AdaptableToolPanel',
        labelDefault: 'Advanced',
        iconKey: 'menu',
        width: 250,
        minWidth: 200,
        maxWidth: 300
    }
];
